import { render } from "./App.vue?vue&type=template&id=6595a306"
const script = {}

import "./App.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script